import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import { initializeUser } from "services/analytics";
import NotFound from "pages/not-found";
import { Viewer } from "components/auth/types";
import { authorizeForRole } from "components/auth/authorize-for-role";
import { MainLayout } from "pages/layouts";
import { useAppliedPropertyFeature } from "components/feature";
import { Feature, UserRole } from "types/gql-types";
import Interests from "./interests/list";
import InterestsUpdate from "./interests/update";

import DocumentList from "./documents";
import Document from "./documents/document";

import SettingsPage from "./settings";


type Props = { viewer: Viewer; }

const ClientDashboard: React.FC<Props> = ({ viewer }) => {
  const userProfileFeatureEnabled = useAppliedPropertyFeature(Feature.USER_PROFILE);
  if (!viewer) return null;
  useEffect(() => {
    const { id: userId, email, fullName, roles: rawRoles, organizationId, properties } = viewer;
    const { id: propertyId, name: propertyName } = properties[0] || {};


    if (userId && email && rawRoles) {
      const roles = Object.values(rawRoles || [""]);
      initializeUser({
        userId,
        fullName: fullName || "",
        roles,
        email,
        organizationId: organizationId || "",
        propertyId: propertyId || "",
        propertyName: propertyName || "",
      });
    }
  }, []);


  return (
    <MainLayout backgroundColor="gray" showHeader>
      <Routes>
        <Route path="submissions" element={<Interests />} />
        <Route path="submissions/:interestListId" element={<InterestsUpdate />} />
        <Route path="submissions/:interestListId/:interestId" element={<InterestsUpdate />} />

        <Route path="documents" element={<DocumentList />} />
        <Route path="documents/:id" element={<Document />} />

        {userProfileFeatureEnabled && (
          <Route path="settings/*" element={<SettingsPage viewer={viewer} />} />
        )}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </MainLayout>
  );
};

export default authorizeForRole<Record<string, unknown>>(
  [UserRole.CLIENT],
  ClientDashboard as unknown as React.FC<Record<string, unknown>>,
);
